import { render, staticRenderFns } from "./FacebookTemplate.vue?vue&type=template&id=24957336&"
import script from "./FacebookTemplate.vue?vue&type=script&lang=js&"
export * from "./FacebookTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports